import React, {useEffect} from 'react'
import {Navigate, Route, Routes, Outlet, useNavigate} from 'react-router-dom'
import {PageTitle, useLayout} from '../../../_metronic/layout/core'
import {HeaderTabs} from './HeaderTabs'
import {ManageProducts} from './manage-products'
import {ManageCategory} from './manage-category'
import {ManageUnit} from './manage-unit'

const ProductCatalogues: React.FC = () => {
  const {company, financialYear, fyEndDate, fyStartDate} = useLayout()
  const navigate = useNavigate()
  useEffect(() => {
    if (!company || !company.value || !financialYear || !financialYear.value) {
      navigate('/companies')
    }
  }, [company.value, financialYear.value])

  return (
    <Routes>
      <Route
        element={
          <>
            <HeaderTabs />
            <Outlet />
          </>
        }
      >
        <Route
          path='manage-products'
          element={
            <>
              <PageTitle>Manage Products</PageTitle>
              <ManageProducts />
            </>
          }
        />
        <Route
          path='manage-category'
          element={
            <>
              <PageTitle>Manage Category</PageTitle>
              <ManageCategory />
            </>
          }
        />
        <Route
          path='manage-unit'
          element={
            <>
              <PageTitle>Manage Unit</PageTitle>
              <ManageUnit />
            </>
          }
        />

        <Route index element={<Navigate to='/product-catalogue/manage-products' />} />
      </Route>
    </Routes>
  )
}

export default ProductCatalogues
